import React from 'react';
import { Box, Card, CardMedia, CardContent, CardActions, colors, Avatar, AvatarGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';
import SimPolygon from './svg/shapes/SimPolygon';
import { SimSlider, SimSliderContainer } from './SimSlider';
import autismPic from 'assets/images/5.webp';

const options = [
	{
		category: 'Autism',
		// media: 'https://www.angelsense.com/wp-content/uploads/2016/09/shutterstock_24826897.jpg',
		media: autismPic,
		title: 'Concerned about child’s development?',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',
		audience: 'For Parents',
		summary: 'Early detection and intervention are critical factors in supporting child’s development',
		users: [
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM=',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg'
		]
	},
	{
		category: 'ABA Therapy',
		media: 'https://images.squarespace-cdn.com/content/v1/5e5e97f2fd9fbc2e803e24d8/1583258884968-OAKT4GMCHN16I1M2NYHX/banner.jpg',
		title: 'Concerned about child’s development?',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',
		audience: 'For Parents',
		summary: 'Right therapy-based intervention makes a big impact on the quaity of life ahead',
		users: [
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM='
		]
	},
	{
		category: 'Parental Counseling',
		media: 'https://www.prevention.psu.edu/uploads/project-heroes/_1800xAUTO_fit_center-center/parents-with-mentor-AdobeStock_196996852-opt.jpg',
		title: 'Need guidance with child’s development?',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',
		audience: 'For Parents',
		summary: 'Managing a child of a neurodevelopmental disorder is hard. Our sessions help you cope well.',
		users: [
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc='
		]
	},
	{
		category: 'Couples Counseling',
		media: 'https://emeryondivorce.com/wp-content/uploads/2020/10/21443C243BC148F38717ED65C6028349.jpeg',
		title: 'Concerned about your marriage / relationship?',
		tutor: 'Dr. Joshua Karamaki, BCBA',
		audience: 'For Parents',
		summary: 'Parents of a special needs child often run into marital challenges. We can help.',
		users: [
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg',
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM='
		]
	}
];

const SimFeaturedServiceSlider = () => {
	const theme = useTheme();

	return (
		<SimSliderContainer>
			<SimSlider>
				{options.map((item, i) => (
					<Box key={i} padding={{ xs: 1, sm: 1, md: 1, lg: 1 }}>
						<Box
							display={'block'}
							width={1}
							height={1}
							sx={{
								textDecoration: 'none',
								transition: 'all .2s ease-in-out',
								'&:hover': {
									transform: `translateY(-${theme.spacing(1 / 2)})`
								}
							}}>
							<Box
								component={Card}
								width={1}
								minHeight={{ xs: '700px', sm: '900px', md: '80vw', lg: '50vw' }}
								height={{ xs: 200, sm: '80vw', md: '80vw', lg: '50vw' }}
								display={'flex'}
								flexDirection={'column'}
								sx={{ backgroundImage: 'none' }}
								paddingBottom={3}>
								<CardMedia
									title={item.title}
									image={item.media}
									sx={{
										position: 'relative',
										height: { xs: 240, sm: 340, md: 280 },
										overflow: 'hidden'
									}}>
									<SimPolygon sx={{ bottom: 0 }} />
									<Box
										display={'flex'}
										justifyContent={'space-between'}
										position={'absolute'}
										padding={2}
										width={1}
										zIndex={2}>
										<Box
											padding={1}
											paddingX={1.5}
											bgcolor={'background.default'}
											boxShadow={5}
											borderRadius={6}
											border={1}
											borderColor={'#bfbfbf'}>
											<SimTypography sx={{ fontWeight: 600 }}>{item.category}</SimTypography>
										</Box>
									</Box>

										<Box
											display={'flex'}
											flexDirection={'row'}
											justifyContent={'space-between'}
											alignContent={'center'}
											position={'absolute'}
											bottom={0}
											padding={1}
											width={1}
											zIndex={2}>
											<Box marginTop={2} height={1} display={'flex'} alignItems={'center'}>
												<Box
													height={1}
													padding={1}
													paddingX={2}
													bgcolor={'background.default'}
													boxShadow={5}
													borderRadius={6}
													border={1}
													borderColor={'#bfbfbf'}
													display={'flex'}
													justifyContent={'center'}
													alignItems={'center'}>
													<SimTypography sx={{ fontWeight: 600 }}>
														{item.audience}
													</SimTypography>
												</Box>
											</Box>

										<SimButton
											variant={'contained'}
											color='primary'
											size='large'
											href={'/services'}>
											See Details
										</SimButton>
									</Box>
								</CardMedia>
								<CardContent>
									<SimTypography variant={'h6'} gutterBottom align={'left'} sx={{ fontWeight: 700 }}>
										{item.title}
									</SimTypography>
									<SimTypography gutterBottom align={'left'} sx={{ fontWeight: 300 }}>
										{item.summary}
									</SimTypography>
									<Box display={'flex'} alignItems={'center'} marginY={2}>
										<Box
											component={'svg'}
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											stroke='currentColor'
											width={24}
											height={24}
											marginRight={1}>
											<path d='M12 14l9-5-9-5-9 5 9 5z' />
											<path d='M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z' />
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												strokeWidth={2}
												d='M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222'
											/>
										</Box>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											{item.tutor}
										</SimTypography>
									</Box>
									<Box marginTop={2} display={'flex'} justifyContent={'space-between'}>
										<AvatarGroup max={4}>
											{item.users.map(u => (
												<Avatar key={u} src={u} />
											))}
										</AvatarGroup>
										<Box display={'flex'} alignItems={'center'}>
											<Box
												component={'svg'}
												width={20}
												height={20}
												xmlns='http://www.w3.org/2000/svg'
												viewBox='0 0 20 20'
												fill='currentColor'
												color={colors.yellow[700]}
												marginRight={1}>
												<path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
											</Box>
											<SimTypography sx={{ fontWeight: 700 }}>5.0</SimTypography>
										</Box>
									</Box>
								</CardContent>
								<Box flexGrow={1} />
								<CardActions
									sx={{
										justifyContent: 'center'
									}}>
									<SimButton variant={'contained'} href={'/contact'} color='primary' size='large'>
										Schedule Now
									</SimButton>
								</CardActions>
							</Box>
						</Box>
					</Box>
				))}
			</SimSlider>
		</SimSliderContainer>
	);
};

export default SimFeaturedServiceSlider;
